module.exports = __webpack_public_path__ + "img/大暴雨.964ffb08.png";